import { OrganizationModel } from "app/models/organizations/organization.model";
import { erpConfigStatus } from "app/types/erp-config.type";
import { ErpType } from "app/shared/enums";

export class ERPConfigModel {
    id: string = '';
    company_id: number | undefined;
    tenant_id: string | undefined;
    erp_type: ErpType | undefined;
    refresh_token: string = '';
    domain: string = '';
    client_id: string = '';
    client_secret: string = '';
    created_at: Date | undefined;
    updated_at: Date | undefined;
    created_by: string | undefined;
    updated_by: string | undefined;
    is_deleted: boolean | undefined;
    deleted_at: Date | undefined;
    deleted_by: string | undefined;
    status: erpConfigStatus = 'NONE';
    organizations: OrganizationModel[] = [];
    is_active: boolean = false;
    has_detail: boolean = false;
    active_organizations: OrganizationModel[] = [];
    error?: string;
    error_code?: string;

    // Tailscale integration fields
    tailscale_ip?: string;
    tailscale_enabled?: boolean;

    // Heartbeat monitoring fields
    last_heartbeat?: Date;
    service_version?: string;
    service_machine?: string;

    constructor(init?: Partial<ERPConfigModel>) {
        this.status = 'NONE';
        if (init) {
            Object.assign(this, init);
            this.active_organizations = this.organizations.filter(x => x.is_active);
        }
    }

    clear(): ERPConfigModel {
        this.refresh_token = '';
        this.created_at = undefined;
        this.updated_at = undefined;
        this.created_by = undefined;
        this.updated_by = undefined;
        this.is_deleted = false;
        this.deleted_at = undefined;
        this.deleted_by = undefined;
        this.status = 'NONE';
        this.is_active = false;
        this.active_organizations = [];


        return this;
    }
}

export class ERPActiveTenantModel {
    id: string | undefined;
    tenantId: string | undefined;
    tenantName: string | undefined;
    tenantType: string | undefined;
    authEventId: string | undefined;
    createdDateUtc: Date | undefined;
    updatedDateUtc: Date | undefined;

    constructor(init?: Partial<ERPActiveTenantModel>) {
        if (init) {
            Object.assign(this, init);
        }
    }

    clear() {
        this.id = undefined;
        this.tenantId = undefined;
        this.tenantName = undefined;
        this.tenantType = undefined;
        this.authEventId = undefined;
        this.createdDateUtc = undefined;
        this.updatedDateUtc = undefined;
    }
}
